import React from 'react';
import { Form, Button, Input, Icon, message } from 'antd';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
// import { withRouter } from 'react-router-dom';

import ErrorContainer from './../components/FormErrorContainer';

const logo = require('./../images/ingv_logo.png');

const FormItem = Form.Item;
const buttonStyle = {
  width: 120,
};
const prefixIconStyle = {
  color: 'rgba(0,0,0,.25)',
};

@inject('authStore')
@inject('userStore')
@observer
class LoginScreen extends React.Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    authStore: PropTypes.object.isRequired,
    userStore: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.props.authStore.reset();
  }

  handleSubmit = e => {
    console.log(`login ... handleSubmit`)
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      // console.log(`login ... err=[${err}]`)
      if (!err) {
        this.props.authStore.login(values.userCode, values.password).then(() => {
          // console.log(`login ... [${this.props.authStore.error.message}]`)
          if (!this.props.authStore.error) {
            // console.log(`login ... [${this.props.authStore.error.message}]`)
            // SERGIO_AUTH_ORIG this.props.history.push('/')
            // SERGIO_AUTH_NEW this.props.history.push('/admin');
            this.props.history.push('/admin');
          }
        });
      }
    });
  };

  render() {
    const { userStore, authStore } = this.props;

    if (userStore.self) {
      message.success(`Hello ${userStore.self.displayName}, you are now logged in.`, 0.8);
      var myDataset = new URLSearchParams(window.location.search).get("dataset");
      // message.success(`IL DATASET E' ${myDataset} <<<<<<<<<<<<`, 10);

      // SERGIO_AUTH_ORIG window.location.href = `/?dataset=${myDataset}`;
      // SERGIO_AUTH_NEW window.location.href = `/admin`;
      window.location.href = `/admin`;

      // return <Redirect to='/' />;
      // return <Redirect to={{
      //   pathname: "/",
      //   search: "?dataset=ingv"
      // }}
      ///>;
    }
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="full-page-form__container">
        <Form onSubmit={this.handleSubmit} className="full-page-form__content">
          <div className="centered">
            <img style={{ width: 80, paddingBottom: 20 }} src={logo} alt="ingv logo" />
          </div>
          <FormItem>
            {getFieldDecorator('userCode', {
              rules: [{ required: true, message: 'Please input your username!' }],
            })(<Input prefix={<Icon type="user" style={prefixIconStyle} />} placeholder="Username" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password!' }],
            })(<Input prefix={<Icon type="lock" style={prefixIconStyle} />} type="password" placeholder="Password" />)}
          </FormItem>
          <ErrorContainer error={authStore.error} />
          <FormItem>
            <div className="space-evenly">
              <Button type="primary" icon="login" style={buttonStyle} htmlType="submit" loading={authStore.inProgress}>
                Log in
              </Button>
            </div>
          </FormItem>
          <div className="space-between">
            <Link to="/">
              <Button type="secondary" icon="left">
                Homepage
              </Button>
            </Link>
          </div>
        </Form>
      </div>
    );
  }
}

export default Form.create()(LoginScreen);



// WEBPACK FOOTER //
// ./src/screens/Login.js